import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-delivery-notes-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './delivery-notes-page.component.html',
  styleUrl: './delivery-notes-page.component.css'
})
export class DeliveryNotesPageComponent {

}
